import { useEffect } from "react";
import { initSmoothScroll } from "@/lib/scroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Problem } from "@/components/Problem";
import { Solution } from "@/components/Solution";
import { HowItWorks } from "@/components/HowItWorks";
import { AuditOffer } from "@/components/AuditOffer";
import { MonthlySupport } from "@/components/MonthlySupport";
import { Trust } from "@/components/Trust";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";

export default function Landing() {
  useEffect(() => {
    const destroy = initSmoothScroll();
    return destroy;
  }, []);

  return (
    <div className="pb-20 md:pb-0" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Solution />
        <HowItWorks />
        <AuditOffer />
        <MonthlySupport />
        <Trust />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
